import { render, staticRenderFns } from "./TableViewRow.vue?vue&type=template&id=0324cc68&scoped=true"
import script from "./TableViewRow.vue?vue&type=script&lang=js"
export * from "./TableViewRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0324cc68",
  null
  
)

export default component.exports